<div *ngFor="let item of pendingNegotiation?.negotiationItems; let i = index">
  <gc-bid-ask-negotiation-item
    [form]="form.matchingItemForm(item)"
    [item]="item"
    [role]="role"
  ></gc-bid-ask-negotiation-item>
</div>
